<template>
  <div class="sugerencias-container">
    <!-- Header con título y botón de refrescar -->
    <div class="row">
      <div class="col-12">
        <card>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h4 class="card-title mb-1">
                <i class="nc-icon nc-email-85"></i> Gestión de Sugerencias
              </h4>
              <p class="card-category mb-0">
                Administra las sugerencias, felicitaciones y reclamos de tus socios
              </p>
            </div>
            <div>
              <button 
                class="btn btn-primary btn-sm" 
                @click="refrescarDatos"
                :disabled="cargando"
              >
                <i class="nc-icon nc-refresh-69"></i> Refrescar
              </button>
            </div>
          </div>
        </card>
      </div>
    </div>

    <!-- Cards de Métricas -->
    <div class="row" v-if="metricas">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card>
          <div slot="header" class="icon-warning">
            <i class="nc-icon nc-time-alarm text-warning"></i>
          </div>
          <div slot="content">
            <p class="card-category">Pendientes</p>
            <h4 class="card-title">{{ metricas.resumen.pendientes || 0 }}</h4>
          </div>
          <div slot="footer">
            <i class="fa fa-clock-o"></i> Por revisar
          </div>
        </stats-card>
      </div>

      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card>
          <div slot="header" class="icon-info">
            <i class="nc-icon nc-glasses-2 text-info"></i>
          </div>
          <div slot="content">
            <p class="card-category">En Revisión</p>
            <h4 class="card-title">{{ metricas.resumen.enRevision || 0 }}</h4>
          </div>
          <div slot="footer">
            <i class="fa fa-eye"></i> En proceso
          </div>
        </stats-card>
      </div>

      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card>
          <div slot="header" class="icon-success">
            <i class="nc-icon nc-check-2 text-success"></i>
          </div>
          <div slot="content">
            <p class="card-category">Resueltas</p>
            <h4 class="card-title">{{ metricas.resumen.resueltas || 0 }}</h4>
          </div>
          <div slot="footer">
            <i class="fa fa-check"></i> Tasa: {{ metricas.resumen.tasaRespuesta || '0%' }}
          </div>
        </stats-card>
      </div>

      <div class="col-lg-3 col-md-6 col-sm-6">
        <stats-card>
          <div slot="header" class="icon-primary">
            <i class="nc-icon nc-chart-bar-32 text-primary"></i>
          </div>
          <div slot="content">
            <p class="card-category">Total</p>
            <h4 class="card-title">{{ metricas.resumen.total || 0 }}</h4>
          </div>
          <div slot="footer">
            <i class="fa fa-users"></i> {{ metricas.resumen.totalAnonimas || 0 }} anónimas
          </div>
        </stats-card>
      </div>
    </div>

    <!-- Filtros -->
    <div class="row">
      <div class="col-12">
        <card>
          <h5 class="card-title mb-3">
            <i class="nc-icon nc-zoom-split"></i> Filtros de Búsqueda
          </h5>
          
          <div class="row">
            <!-- Filtro Estado -->
            <div class="col-md-3 col-sm-6">
              <div class="form-group">
                <label>Estado</label>
                <el-select 
                  v-model="filtros.estado" 
                  placeholder="Todos los estados"
                  clearable
                  class="w-100"
                  @change="aplicarFiltros"
                >
                  <el-option value="PENDIENTE" label="Pendiente">
                    <span class="badge badge-warning">Pendiente</span>
                  </el-option>
                  <el-option value="EN REVISIÓN" label="En Revisión">
                    <span class="badge badge-info">En Revisión</span>
                  </el-option>
                  <el-option value="RESUELTA" label="Resuelta">
                    <span class="badge badge-success">Resuelta</span>
                  </el-option>
                  <el-option value="CERRADA" label="Cerrada">
                    <span class="badge badge-secondary">Cerrada</span>
                  </el-option>
                </el-select>
              </div>
            </div>

            <!-- Filtro Tipo -->
            <div class="col-md-3 col-sm-6">
              <div class="form-group">
                <label>Tipo</label>
                <el-select 
                  v-model="filtros.tipo" 
                  placeholder="Todos los tipos"
                  clearable
                  class="w-100"
                  @change="aplicarFiltros"
                >
                  <el-option value="SUGERENCIA" label="Sugerencia">
                    <i class="nc-icon nc-bulb-63 text-primary"></i> Sugerencia
                  </el-option>
                  <el-option value="FELICITACIÓN" label="Felicitación">
                    <i class="nc-icon nc-favourite-28 text-success"></i> Felicitación
                  </el-option>
                  <el-option value="RECLAMO" label="Reclamo">
                    <i class="nc-icon nc-alert-circle-i text-danger"></i> Reclamo
                  </el-option>
                  <el-option value="OTRO" label="Otro">
                    <i class="nc-icon nc-chat-33 text-secondary"></i> Otro
                  </el-option>
                </el-select>
              </div>
            </div>

            <!-- Filtro Fecha Desde -->
            <div class="col-md-3 col-sm-6">
              <div class="form-group">
                <label>Fecha Desde</label>
                <el-date-picker
                  v-model="filtros.fechaDesde"
                  type="date"
                  placeholder="Fecha inicial"
                  format="dd-MM-yyyy"
                  value-format="yyyy-MM-dd"
                  clearable
                  class="w-100"
                  @change="aplicarFiltros"
                />
              </div>
            </div>

            <!-- Filtro Fecha Hasta -->
            <div class="col-md-3 col-sm-6">
              <div class="form-group">
                <label>Fecha Hasta</label>
                <el-date-picker
                  v-model="filtros.fechaHasta"
                  type="date"
                  placeholder="Fecha final"
                  format="dd-MM-yyyy"
                  value-format="yyyy-MM-dd"
                  clearable
                  class="w-100"
                  @change="aplicarFiltros"
                />
              </div>
            </div>
          </div>

          <!-- Botones de acción rápida -->
          <div class="row mt-2">
            <div class="col-12">
              <button 
                class="btn btn-sm btn-outline-warning mr-2" 
                @click="filtrarPorEstado('PENDIENTE')"
              >
                <i class="nc-icon nc-time-alarm"></i> Solo Pendientes
              </button>
              <button 
                class="btn btn-sm btn-outline-info mr-2" 
                @click="filtrarPorEstado('EN REVISIÓN')"
              >
                <i class="nc-icon nc-glasses-2"></i> En Revisión
              </button>
              <button 
                class="btn btn-sm btn-outline-danger mr-2" 
                @click="filtrarPorTipo('RECLAMO')"
              >
                <i class="nc-icon nc-alert-circle-i"></i> Solo Reclamos
              </button>
              <button 
                class="btn btn-sm btn-outline-secondary" 
                @click="limpiarFiltros"
              >
                <i class="nc-icon nc-simple-remove"></i> Limpiar Filtros
              </button>
            </div>
          </div>
        </card>
      </div>
    </div>

    <!-- Tabla de Sugerencias -->
    <div class="row">
      <div class="col-12">
        <card>
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="card-title mb-0">
              <i class="nc-icon nc-bullet-list-67"></i> 
              Listado de Sugerencias
              <span class="badge badge-primary ml-2" v-if="paginacion.cantidadTotalRegistros">
                {{ paginacion.cantidadTotalRegistros }} registros
              </span>
            </h5>
            
            <!-- Registros por página -->
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-2">Mostrar:</label>
              <el-select 
                v-model="filtros.limitePagina" 
                size="small"
                @change="cambiarLimitePagina"
                style="width: 80px;"
              >
                <el-option :value="10" label="10" />
                <el-option :value="25" label="25" />
                <el-option :value="50" label="50" />
                <el-option :value="100" label="100" />
              </el-select>
            </div>
          </div>

          <!-- Loader -->
          <div v-if="cargando" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
            <p class="mt-2 text-muted">Cargando sugerencias...</p>
          </div>

          <!-- Tabla -->
          <div v-else-if="sugerencias.length > 0" class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Tipo</th>
                  <th>Origen</th>
                  <th>Socio</th>
                  <th>Asunto</th>
                  <th>Estado</th>
                  <th class="text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="sugerencia in sugerencias" :key="sugerencia._id">
                  <!-- Fecha -->
                  <td>
                    <small class="text-muted">
                      {{ formatearFecha(sugerencia.fechaCreacion) }}
                    </small>
                  </td>

                  <!-- Tipo -->
                  <td>
                    <span :class="getBadgeTipo(sugerencia.tipo)">
                      {{ getTipoIcon(sugerencia.tipo) }} {{ sugerencia.tipo }}
                    </span>
                  </td>

                  <!-- Origen -->
                  <td>
                    <span :class="getBadgeOrigen(sugerencia.origen)">
                      {{ getOrigenIcon(sugerencia.origen) }} {{ getOrigenTexto(sugerencia.origen) }}
                    </span>
                  </td>

                  <!-- Socio -->
                  <td>
                    <div>
                      <strong>{{ sugerencia.nombreSocio }}</strong>
                      <br>
                      <small class="text-muted">
                        <i class="nc-icon nc-badge" v-if="!sugerencia.anonimo"></i>
                        <i class="nc-icon nc-lock-circle-open" v-else></i>
                        {{ sugerencia.rut }}
                      </small>
                    </div>
                  </td>

                  <!-- Asunto -->
                  <td>
                    <div style="max-width: 300px;">
                      <strong>{{ sugerencia.asunto }}</strong>
                      <br>
                      <small class="text-muted">
                        {{ truncarTexto(sugerencia.mensaje, 80) }}
                      </small>
                    </div>
                  </td>

                  <!-- Estado -->
                  <td>
                    <span :class="getBadgeEstado(sugerencia.estado)">
                      {{ getEstadoIcon(sugerencia.estado) }} {{ sugerencia.estado }}
                    </span>
                    <div v-if="sugerencia.respuesta">
                      <small class="text-success">
                        <i class="nc-icon nc-check-2"></i> Respondida
                      </small>
                    </div>
                  </td>

                  <!-- Acciones -->
                  <td class="text-right">
                    <button
                      class="btn btn-sm btn-info btn-icon"
                      @click="abrirModalDetalle(sugerencia)"
                      title="Ver Detalle"
                    >
                      <i class="nc-icon nc-zoom-split"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-success btn-icon ml-1"
                      @click="abrirModalResponder(sugerencia)"
                      title="Responder"
                      v-if="sugerencia.estado !== 'RESUELTA' && sugerencia.estado !== 'CERRADA'"
                    >
                      <i class="nc-icon nc-send"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Sin resultados -->
          <div v-else class="text-center py-5">
            <i class="nc-icon nc-zoom-split" style="font-size: 48px; color: #ccc;"></i>
            <p class="text-muted mt-3">No se encontraron sugerencias con los filtros aplicados</p>
            <button class="btn btn-sm btn-primary" @click="limpiarFiltros">
              <i class="nc-icon nc-simple-remove"></i> Limpiar Filtros
            </button>
          </div>

          <!-- Paginación -->
          <div v-if="paginacion.totalPaginas > 1" class="mt-4">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="paginacion.cantidadTotalRegistros"
              :page-size="paginacion.registrosPorPagina"
              :current-page="paginacion.paginaActual + 1"
              @current-change="cambiarPagina"
            />
          </div>
        </card>
      </div>
    </div>

    <!-- Sección Link Público y QR -->
    <div class="row">
      <div class="col-12">
        <card>
          <h5 class="card-title mb-3">
            <i class="nc-icon nc-world-2"></i> Formulario Público de Sugerencias
          </h5>
          <p class="text-muted mb-4">
            Comparte este enlace con tus socios para que puedan enviar sugerencias, felicitaciones o reclamos
            sin necesidad de descargar la app móvil.
          </p>

          <div class="row">
            <!-- Copiar Link -->
            <div class="col-md-6 mb-3">
              <div class="card bg-light h-100">
                <div class="card-body">
                  <h6 class="card-subtitle mb-3">
                    <i class="nc-icon nc-link-72"></i> Link Público
                  </h6>
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      class="form-control"
                      :value="linkPublico"
                      readonly
                      @click="$event.target.select()"
                    >
                    <div class="input-group-append">
                      <button
                        class="btn btn-primary"
                        type="button"
                        @click="copiarLink"
                      >
                        <i class="nc-icon nc-single-copy-04"></i> Copiar
                      </button>
                    </div>
                  </div>
                  <small class="text-muted">
                    <i class="nc-icon nc-bulb-63"></i> 
                    Usa este link en tus redes sociales, emails o sitio web
                  </small>
                </div>
              </div>
            </div>

            <!-- Generar QR -->
            <div class="col-md-6 mb-3">
              <div class="card bg-light h-100">
                <div class="card-body">
                  <h6 class="card-subtitle mb-3">
                    <i class="nc-icon nc-mobile"></i> Código QR
                  </h6>
                  <button
                    class="btn btn-success btn-block mb-3"
                    @click="generarYDescargarQR"
                    :disabled="generandoQR"
                  >
                    <span v-if="!generandoQR">
                      <i class="nc-icon nc-cloud-download-93"></i> Generar y Descargar QR
                    </span>
                    <span v-else>
                      <i class="fa fa-spinner fa-spin"></i> Generando...
                    </span>
                  </button>
                  <small class="text-muted">
                    <i class="nc-icon nc-bulb-63"></i> 
                    Imprime el código QR y colócalo en recepción o vestidores
                  </small>
                  
                  <!-- Preview QR si existe -->
                  <div v-if="qrImageUrl" class="text-center mt-3">
                    <img :src="qrImageUrl" alt="QR Code" class="img-fluid" style="max-width: 200px;">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Información adicional -->
          <div class="alert alert-info mt-3">
            <i class="nc-icon nc-alert-circle-i"></i>
            <strong>Información:</strong> 
            El formulario público permite a los socios enviar sugerencias de forma anónima o identificándose. 
            Todas las sugerencias aparecerán en esta tabla con el origen "🌐 Web".
          </div>
        </card>
      </div>
    </div>

    <!-- Modal Detalle -->
    <el-dialog
      :visible.sync="modalDetalle.visible"
      width="700px"
      :before-close="cerrarModalDetalle"
    >
      <div slot="title">
        <h4 class="mb-0">
          <i class="nc-icon nc-email-85"></i> Detalle de Sugerencia
        </h4>
      </div>

      <div v-if="modalDetalle.sugerencia">
        <!-- Header con tipo y estado -->
        <div class="row mb-3">
          <div class="col-6">
            <strong>Tipo:</strong>
            <span :class="getBadgeTipo(modalDetalle.sugerencia.tipo)" class="ml-2">
              {{ getTipoIcon(modalDetalle.sugerencia.tipo) }} {{ modalDetalle.sugerencia.tipo }}
            </span>
          </div>
          <div class="col-6 text-right">
            <strong>Estado:</strong>
            <span :class="getBadgeEstado(modalDetalle.sugerencia.estado)" class="ml-2">
              {{ getEstadoIcon(modalDetalle.sugerencia.estado) }} {{ modalDetalle.sugerencia.estado }}
            </span>
          </div>
        </div>

        <!-- Información del socio -->
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-subtitle mb-2">
              <i class="nc-icon nc-single-02"></i> Información del Socio
            </h6>
            <div class="row">
              <div class="col-6">
                <strong>Nombre:</strong> {{ modalDetalle.sugerencia.nombreSocio }}
              </div>
              <div class="col-6">
                <strong>RUT:</strong> {{ modalDetalle.sugerencia.rut }}
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-6">
                <strong>Fecha:</strong> {{ modalDetalle.sugerencia.fechaCreacion }}
              </div>
              <div class="col-6">
                <strong>Anónimo:</strong> 
                <span v-if="modalDetalle.sugerencia.anonimo" class="text-warning">
                  <i class="nc-icon nc-lock-circle-open"></i> Sí
                </span>
                <span v-else class="text-success">
                  <i class="nc-icon nc-badge"></i> No
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Información de Origen (Web Pública) -->
        <div v-if="esWebPublica(modalDetalle.sugerencia)" class="card bg-info mt-3">
          <div class="card-body">
            <h6 class="card-subtitle mb-2 text-white">
              <i class="nc-icon nc-world-2"></i> Información de Origen Web Pública
            </h6>
            <div class="row">
              <div class="col-6">
                <strong class="text-white">Origen:</strong> 
                <span class="badge badge-light ml-1">
                  🌐 Web Pública
                </span>
              </div>
              <div class="col-6" v-if="modalDetalle.sugerencia.nombreSucursal">
                <strong class="text-white">Sucursal:</strong> 
                <span class="text-white">{{ modalDetalle.sugerencia.nombreSucursal }}</span>
              </div>
            </div>
            <div class="row mt-2" v-if="modalDetalle.sugerencia.ipOrigen">
              <div class="col-12">
                <strong class="text-white">IP de Origen:</strong> 
                <code class="bg-white text-dark px-2 py-1 rounded">{{ modalDetalle.sugerencia.ipOrigen }}</code>
              </div>
            </div>
          </div>
        </div>

        <!-- Información de Origen (App Móvil) -->
        <div v-else class="alert alert-light mt-3">
          <div class="d-flex align-items-center">
            <i class="nc-icon nc-mobile text-primary" style="font-size: 1.5rem; margin-right: 10px;"></i>
            <div>
              <strong>Origen:</strong> 
              <span class="badge badge-primary ml-1">📱 App Móvil</span>
              <br>
              <small class="text-muted">Enviado desde la aplicación móvil de socios</small>
            </div>
          </div>
        </div>

        <!-- Asunto y Mensaje -->
        <div class="mt-3">
          <h6><i class="nc-icon nc-paper"></i> Asunto:</h6>
          <p class="font-weight-bold">{{ modalDetalle.sugerencia.asunto }}</p>
        </div>

        <div class="mt-3">
          <h6><i class="nc-icon nc-chat-33"></i> Mensaje:</h6>
          <div class="card">
            <div class="card-body bg-white">
              <p style="white-space: pre-wrap;">{{ modalDetalle.sugerencia.mensaje }}</p>
            </div>
          </div>
        </div>

        <!-- Respuesta (si existe) -->
        <div v-if="modalDetalle.sugerencia.respuesta" class="mt-3">
          <h6 class="text-success">
            <i class="nc-icon nc-send"></i> Respuesta del Gimnasio:
          </h6>
          <div class="card border-success">
            <div class="card-body bg-light">
              <p style="white-space: pre-wrap;">{{ modalDetalle.sugerencia.respuesta }}</p>
              <hr>
              <small class="text-muted">
                <strong>Respondido por:</strong> {{ modalDetalle.sugerencia.responsableRespuesta || 'N/A' }}
                <br>
                <strong>Fecha respuesta:</strong> {{ modalDetalle.sugerencia.fechaRespuesta || 'N/A' }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <button class="btn btn-secondary" @click="cerrarModalDetalle">
          <i class="nc-icon nc-simple-remove"></i> Cerrar
        </button>
        <button 
          class="btn btn-success" 
          @click="abrirModalResponder(modalDetalle.sugerencia)"
          v-if="modalDetalle.sugerencia && modalDetalle.sugerencia.estado !== 'RESUELTA' && modalDetalle.sugerencia.estado !== 'CERRADA'"
        >
          <i class="nc-icon nc-send"></i> Responder
        </button>
      </span>
    </el-dialog>

    <!-- Modal Responder -->
    <el-dialog
      :visible.sync="modalResponder.visible"
      width="650px"
      :before-close="cerrarModalResponder"
    >
      <div slot="title">
        <h4 class="mb-0">
          <i class="nc-icon nc-send"></i> Responder Sugerencia
        </h4>
      </div>

      <div v-if="modalResponder.sugerencia">
        <!-- Info breve de la sugerencia -->
        <div class="alert alert-info">
          <strong>Asunto:</strong> {{ modalResponder.sugerencia.asunto }}
          <br>
          <strong>De:</strong> {{ modalResponder.sugerencia.nombreSocio }} ({{ modalResponder.sugerencia.rut }})
        </div>

        <!-- Formulario -->
        <div class="form-group">
          <label>Nuevo Estado <span class="text-danger">*</span></label>
          <el-select 
            v-model="modalResponder.form.estado" 
            placeholder="Selecciona el nuevo estado"
            class="w-100"
          >
            <el-option value="EN REVISIÓN" label="En Revisión">
              <span class="badge badge-info">En Revisión</span>
            </el-option>
            <el-option value="RESUELTA" label="Resuelta">
              <span class="badge badge-success">Resuelta</span>
            </el-option>
            <el-option value="CERRADA" label="Cerrada">
              <span class="badge badge-secondary">Cerrada</span>
            </el-option>
          </el-select>
          <small class="form-text text-muted">
            Selecciona el estado apropiado según tu respuesta
          </small>
        </div>

        <div class="form-group">
          <label>Tu Respuesta</label>
          <textarea
            v-model="modalResponder.form.respuesta"
            class="form-control"
            rows="6"
            placeholder="Escribe aquí tu respuesta al socio (opcional si solo cambias el estado)..."
            maxlength="2000"
          ></textarea>
          <small class="form-text text-muted">
            {{ modalResponder.form.respuesta ? modalResponder.form.respuesta.length : 0 }} / 2000 caracteres
          </small>
        </div>

        <div class="alert alert-warning">
          <i class="nc-icon nc-alert-circle-i"></i>
          <strong>Nota:</strong> Al menos debes cambiar el estado o proporcionar una respuesta.
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <button 
          class="btn btn-secondary" 
          @click="cerrarModalResponder"
          :disabled="modalResponder.enviando"
        >
          <i class="nc-icon nc-simple-remove"></i> Cancelar
        </button>
        <button 
          class="btn btn-success" 
          @click="enviarRespuesta"
          :disabled="modalResponder.enviando || !validarFormularioResponder()"
        >
          <i class="nc-icon nc-send"></i>
          {{ modalResponder.enviando ? 'Enviando...' : 'Enviar Respuesta' }}
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import StatsCard from 'src/components/UIComponents/Cards/StatsCard';
import { DatePicker, Select, Option, Pagination, Dialog } from 'element-ui';
import Swal from 'sweetalert2';

export default {
  name: 'Sugerencias',
  components: {
    StatsCard,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Pagination.name]: Pagination,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      cargando: false,
      sugerencias: [],
      metricas: null,
      
      // Filtros
      filtros: {
        pagina: 0,
        limitePagina: 10,
        estado: null,
        tipo: null,
        fechaDesde: null,
        fechaHasta: null
      },

      // Paginación
      paginacion: {
        cantidadTotalRegistros: 0,
        registrosPorPagina: 10,
        paginaActual: 0,
        totalPaginas: 0,
        hasNextPage: false,
        hasPrevPage: false
      },

      // Modal Detalle
      modalDetalle: {
        visible: false,
        sugerencia: null
      },

      // Modal Responder
      modalResponder: {
        visible: false,
        sugerencia: null,
        enviando: false,
        form: {
          estado: '',
          respuesta: ''
        }
      },

      // Link Público y QR
      linkPublico: '',
      qrImageUrl: null,
      generandoQR: false
    };
  },

  mounted() {
    this.inicializar();
    this.generarLinkPublico();
  },

  methods: {
    /**
     * Inicializar componente
     */
    async inicializar() {
      await this.cargarMetricas();
      await this.cargarSugerencias();
    },

    /**
     * Refrescar todos los datos
     */
    async refrescarDatos() {
      await this.inicializar();
      this.$notify({
        type: 'success',
        message: 'Datos actualizados correctamente',
        icon: 'nc-icon nc-check-2'
      });
    },

    /**
     * Cargar métricas globales
     */
    async cargarMetricas() {
      try {
        const payload = {
          Header: {
            Operacion: '/v1/sugerencias/metricas'
          },
          Auth: {
            Token: sessionStorage.getItem('jCxbraoQeD')
          },
          Body: {
            estado: this.filtros.estado,
            tipo: this.filtros.tipo,
            fechaDesde: this.filtros.fechaDesde,
            fechaHasta: this.filtros.fechaHasta
          }
        };

        const response = await this.$CentralGymOPS_API.post('/', payload);
        
        if (response.data.result && response.data.result.status === 'success') {
          this.metricas = response.data.dataOut.metricas;
        }
      } catch (error) {
        console.error('Error al cargar métricas:', error);
        this.$logger.error('Error al cargar métricas de sugerencias', error);
      }
    },

    /**
     * Cargar sugerencias con filtros y paginación
     */
    async cargarSugerencias() {
      this.cargando = true;
      
      try {
        const payload = {
          Header: {
            Operacion: '/v1/sugerencias/consultar-paginadas'
          },
          Auth: {
            Token: sessionStorage.getItem('jCxbraoQeD')
          },
          Body: {
            pagina: this.filtros.pagina,
            limitePagina: this.filtros.limitePagina,
            estado: this.filtros.estado,
            tipo: this.filtros.tipo,
            fechaDesde: this.filtros.fechaDesde,
            fechaHasta: this.filtros.fechaHasta
          }
        };

        const response = await this.$CentralGymOPS_API.post('/', payload);
        
        if (response.data.result && response.data.result.status === 'success') {
          const dataOut = response.data.dataOut;
          this.sugerencias = dataOut.registros || [];
          this.paginacion = dataOut.paginacion || {};
        }
      } catch (error) {
        console.error('Error al cargar sugerencias:', error);
        this.$logger.error('Error al cargar sugerencias', error);
        
        Swal.fire({
          title: 'Error',
          text: 'No se pudieron cargar las sugerencias. Por favor, intenta nuevamente.',
          icon: 'error',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#ef5350'
        });
      } finally {
        this.cargando = false;
      }
    },

    /**
     * Aplicar filtros (resetea a página 0)
     */
    async aplicarFiltros() {
      this.filtros.pagina = 0;
      await this.cargarMetricas();
      await this.cargarSugerencias();
    },

    /**
     * Limpiar todos los filtros
     */
    async limpiarFiltros() {
      this.filtros = {
        pagina: 0,
        limitePagina: 10,
        estado: null,
        tipo: null,
        fechaDesde: null,
        fechaHasta: null
      };
      await this.aplicarFiltros();
    },

    /**
     * Filtrar por estado específico
     */
    async filtrarPorEstado(estado) {
      this.filtros.estado = estado;
      await this.aplicarFiltros();
    },

    /**
     * Filtrar por tipo específico
     */
    async filtrarPorTipo(tipo) {
      this.filtros.tipo = tipo;
      await this.aplicarFiltros();
    },

    /**
     * Cambiar página
     */
    async cambiarPagina(pagina) {
      this.filtros.pagina = pagina - 1; // El componente envía 1-indexed, el API espera 0-indexed
      await this.cargarSugerencias();
    },

    /**
     * Cambiar límite de página
     */
    async cambiarLimitePagina() {
      this.filtros.pagina = 0;
      await this.cargarSugerencias();
    },

    /**
     * Abrir modal de detalle
     */
    abrirModalDetalle(sugerencia) {
      this.modalDetalle.sugerencia = { ...sugerencia };
      this.modalDetalle.visible = true;
    },

    /**
     * Cerrar modal de detalle
     */
    cerrarModalDetalle() {
      this.modalDetalle.visible = false;
      this.modalDetalle.sugerencia = null;
    },

    /**
     * Abrir modal de responder
     */
    abrirModalResponder(sugerencia) {
      // Cerrar modal de detalle si está abierto
      this.cerrarModalDetalle();

      this.modalResponder.sugerencia = { ...sugerencia };
      this.modalResponder.form = {
        estado: '',
        respuesta: ''
      };
      this.modalResponder.visible = true;
    },

    /**
     * Cerrar modal de responder
     */
    cerrarModalResponder() {
      this.modalResponder.visible = false;
      this.modalResponder.sugerencia = null;
      this.modalResponder.form = {
        estado: '',
        respuesta: ''
      };
    },

    /**
     * Validar formulario de responder
     */
    validarFormularioResponder() {
      return this.modalResponder.form.estado || this.modalResponder.form.respuesta.trim();
    },

    /**
     * Enviar respuesta
     */
    async enviarRespuesta() {
      if (!this.validarFormularioResponder()) {
        Swal.fire({
          title: 'Datos Incompletos',
          text: 'Debes cambiar el estado o proporcionar una respuesta.',
          icon: 'warning',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#ffa726'
        });
        return;
      }

      this.modalResponder.enviando = true;

      try {
        const payload = {
          Header: {
            Operacion: '/v1/sugerencias/responder'
          },
          Auth: {
            Token: sessionStorage.getItem('jCxbraoQeD')
          },
          Body: {
            idSugerencia: this.modalResponder.sugerencia._id,
            estado: this.modalResponder.form.estado || undefined,
            respuesta: this.modalResponder.form.respuesta.trim() || undefined
          }
        };

        const response = await this.$CentralGymOPS_API.post('/', payload);
        
        if (response.data.result && response.data.result.status === 'success') {
          Swal.fire({
            title: '¡Éxito!',
            text: 'La sugerencia ha sido actualizada correctamente.',
            icon: 'success',
            confirmButtonText: 'Aceptar',
            confirmButtonColor: '#6bd098'
          });

          this.cerrarModalResponder();
          await this.refrescarDatos();
        }
      } catch (error) {
        console.error('Error al responder sugerencia:', error);
        this.$logger.error('Error al responder sugerencia', error);
        
        Swal.fire({
          title: 'Error',
          text: 'No se pudo enviar la respuesta. Por favor, intenta nuevamente.',
          icon: 'error',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#ef5350'
        });
      } finally {
        this.modalResponder.enviando = false;
      }
    },

    /**
     * Obtener clase de badge según tipo
     */
    getBadgeTipo(tipo) {
      const badges = {
        'SUGERENCIA': 'badge badge-primary',
        'FELICITACIÓN': 'badge badge-success',
        'RECLAMO': 'badge badge-danger',
        'OTRO': 'badge badge-secondary'
      };
      return badges[tipo] || 'badge badge-secondary';
    },

    /**
     * Obtener icono según tipo
     */
    getTipoIcon(tipo) {
      const icons = {
        'SUGERENCIA': '💡',
        'FELICITACIÓN': '👍',
        'RECLAMO': '⚠️',
        'OTRO': '💬'
      };
      return icons[tipo] || '💬';
    },

    /**
     * Obtener clase de badge según estado
     */
    getBadgeEstado(estado) {
      const badges = {
        'PENDIENTE': 'badge badge-warning',
        'EN REVISIÓN': 'badge badge-info',
        'RESUELTA': 'badge badge-success',
        'CERRADA': 'badge badge-secondary'
      };
      return badges[estado] || 'badge badge-secondary';
    },

    /**
     * Obtener icono según estado
     */
    getEstadoIcon(estado) {
      const icons = {
        'PENDIENTE': '⏳',
        'EN REVISIÓN': '👁️',
        'RESUELTA': '✅',
        'CERRADA': '📁'
      };
      return icons[estado] || '📁';
    },

    /**
     * Formatear fecha
     */
    formatearFecha(fecha) {
      if (!fecha) return 'N/A';
      return fecha;
    },

    /**
     * Truncar texto
     */
    truncarTexto(texto, maxLength) {
      if (!texto) return '';
      if (texto.length <= maxLength) return texto;
      return texto.substring(0, maxLength) + '...';
    },

    /**
     * Obtener clase de badge según origen
     */
    getBadgeOrigen(origen) {
      if (origen === 'WEB_PUBLICA') {
        return 'badge badge-info';
      }
      return 'badge badge-primary';
    },

    /**
     * Obtener icono según origen
     */
    getOrigenIcon(origen) {
      if (origen === 'WEB_PUBLICA') {
        return '🌐';
      }
      return '📱';
    },

    /**
     * Obtener texto según origen
     */
    getOrigenTexto(origen) {
      if (origen === 'WEB_PUBLICA') {
        return 'Web';
      }
      return 'App';
    },

    /**
     * Verificar si es web pública
     */
    esWebPublica(sugerencia) {
      return sugerencia && sugerencia.origen === 'WEB_PUBLICA';
    },

    /**
     * Generar link público
     */
    generarLinkPublico() {
      // Obtener datos de la sesión (claves correctas del sistema)
      const idEmpresa = sessionStorage.getItem('eId') || ''; // ID de la empresa
      const idSucursal = sessionStorage.getItem('nu5za9cv6q') || ''; // ID de la sucursal

      // Construir URL base
      const baseUrl = window.location.origin;
      
      // Construir URL completa SOLO con los 2 parámetros obligatorios
      const params = new URLSearchParams({
        token: idEmpresa,
        s: idSucursal
      });

      this.linkPublico = `${baseUrl}/sugerencias-publicas?${params.toString()}`;
      
      // Log para debugging
      this.$logger.log('Link público generado:', {
        idEmpresa,
        idSucursal,
        link: this.linkPublico
      });
    },

    /**
     * Copiar link al portapapeles
     */
    async copiarLink() {
      try {
        await navigator.clipboard.writeText(this.linkPublico);
        
        this.$notify({
          type: 'success',
          message: 'Link copiado al portapapeles',
          icon: 'nc-icon nc-check-2',
          verticalAlign: 'top',
          horizontalAlign: 'right'
        });
      } catch (error) {
        console.error('Error al copiar:', error);
        
        // Fallback para navegadores antiguos
        const textarea = document.createElement('textarea');
        textarea.value = this.linkPublico;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        
        try {
          document.execCommand('copy');
          this.$notify({
            type: 'success',
            message: 'Link copiado al portapapeles',
            icon: 'nc-icon nc-check-2',
            verticalAlign: 'top',
            horizontalAlign: 'right'
          });
        } catch (err) {
          this.$notify({
            type: 'danger',
            message: 'No se pudo copiar el link',
            icon: 'nc-icon nc-simple-remove',
            verticalAlign: 'top',
            horizontalAlign: 'right'
          });
        } finally {
          document.body.removeChild(textarea);
        }
      }
    },

    /**
     * Generar y descargar código QR
     */
    async generarYDescargarQR() {
      this.generandoQR = true;

      try {
        // URL de la API de QR Server
        const qrApiUrl = 'https://api.qrserver.com/v1/create-qr-code/';
        const params = new URLSearchParams({
          size: '300x300',
          data: this.linkPublico
        });

        const qrUrl = `${qrApiUrl}?${params.toString()}`;
        
        // Guardar URL para preview
        this.qrImageUrl = qrUrl;

        // Descargar la imagen
        const response = await fetch(qrUrl);
        const blob = await response.blob();
        
        // Crear link de descarga
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `QR-Sugerencias-${Date.now()}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

        this.$notify({
          type: 'success',
          message: 'Código QR generado y descargado exitosamente',
          icon: 'nc-icon nc-check-2',
          verticalAlign: 'top',
          horizontalAlign: 'right'
        });
      } catch (error) {
        console.error('Error al generar QR:', error);
        this.$logger.error('Error al generar QR', error);
        
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo generar el código QR. Por favor, intenta nuevamente.',
          confirmButtonColor: '#ef5350'
        });
      } finally {
        this.generandoQR = false;
      }
    }
  }
};
</script>

<style scoped>
.sugerencias-container {
  padding: 20px 0;
}

.badge {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}

.icon-warning,
.icon-info,
.icon-success,
.icon-primary {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.icon-warning {
  background: linear-gradient(60deg, #ffa726, #fb8c00);
}

.icon-info {
  background: linear-gradient(60deg, #26c6da, #00acc1);
}

.icon-success {
  background: linear-gradient(60deg, #66bb6a, #43a047);
}

.icon-primary {
  background: linear-gradient(60deg, #ab47bc, #8e24aa);
}

.table tbody tr {
  cursor: pointer;
  transition: all 0.3s ease;
}

.table tbody tr:hover {
  background-color: #f5f5f5;
  transform: translateY(-2px);
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.btn-icon {
  width: 32px;
  height: 32px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.el-pagination {
  text-align: center;
}

/* Ajustes para Element UI */
.el-select,
.el-date-picker {
  width: 100%;
}

/* Scrollbar personalizado para textarea */
textarea::-webkit-scrollbar {
  width: 8px;
}

textarea::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

textarea::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

textarea::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>

